
export const pushConditionally = (itemsToPush, condition, arr) =>
    condition && Array.isArray(itemsToPush)
        ? [ ...arr, ...itemsToPush ]

    : condition
        ? [ ...arr, itemsToPush ]

    : arr;
